import objectDeepWalk from './objectDeepWalk';
import toCamelCase from './toCamelCase';

const camelizeObject = obj => objectDeepWalk(obj, toCamelCase);

export default camelizeObject;
